import React, { useState, useEffect, forwardRef } from "react";
import { SimpleTreeView, TreeItem } from "@mui/x-tree-view";
import { Checkbox, FormControlLabel, TextField } from "@mui/material";
import { ExpandMore, ChevronRight } from "@mui/icons-material";
import { countSelectedCheckboxes } from "../../modules/authentication/shared/utils";

const TreeNode = ({ node, checkedNodes, indeterminateNodes, onToggle, assetTypeCount, regionsCount, vendorsCount, modelsCount, accountsCount, cloudRegionsCount, resourceTypesCount, onpremCount, cloudCount, onpremVendorsCount, cloudVendorsCount }:any) => {
  const isChecked = checkedNodes.has(node.id);
  const isIndeterminate = indeterminateNodes.has(node.id);

  const handleCheck = (event:any) => {
    onToggle(node.id, event.target.checked);  
  };

  return (
    <TreeItem
    sx={{ "& .MuiTreeItem-label": { fontSize: "13px" } }}
      itemId={node.id}
      label={
        <div style={{ display: "flex", alignItems: "center" }} title={node.label}>
          <Checkbox
            sx={{ paddingTop: "2px", paddingBottom: "2px" }}
            checked={isChecked}
            indeterminate={isIndeterminate}
            onChange={handleCheck}
          />
          {node.label === "On-Prem" && (
            <span style={{ marginRight: "6px", display: "inline-flex", alignItems: "center" }}>
              <span style={{
                width: "10px",
                height: "10px",
                borderRadius: "50%",
                backgroundColor: "#1976d2",
                display: "inline-block",
              }} />
            </span>
          )}
            {node.label === "Cloud" && (
            <span style={{ marginRight: "6px", display: "inline-flex", alignItems: "center" }}>
              <span style={{
                width: "10px",
                height: "10px",
                borderRadius: "50%",
                backgroundColor: "#FE6568",
                display: "inline-block",
              }} />
            </span>
          )}
          {node.label}
          {node.label === "On-Prem" && (
            <span style={{ marginLeft: "8px", fontSize: "12px", color: "#888", display: "flex", alignItems: "center" }}>
              <span style={{ 
              display: "inline-flex", 
              justifyContent: "center", 
              alignItems: "center", 
              width: "20px", 
              height: "20px", 
              borderRadius: "50%", 
              backgroundColor: "#1976d2", 
              color: "white", 
              fontSize: "12px", 
              marginRight: "4px" 
              }}>
              {onpremCount}
              </span>
            </span>
          )}
          {node.label === "Cloud" && (
            <span style={{ marginLeft: "8px", fontSize: "12px", color: "#888", display: "flex", alignItems: "center" }}>
              <span style={{ 
              display: "inline-flex", 
              justifyContent: "center", 
              alignItems: "center", 
              width: "20px", 
              height: "20px", 
              borderRadius: "50%", 
              backgroundColor: "#FE6568", 
              color: "white", 
              fontSize: "12px", 
              marginRight: "4px" 
              }}>
              {cloudCount}
              </span>
            </span>
          )}

          {node.label === "Vendors" && (
            <span style={{ marginLeft: "8px", fontSize: "12px", color: "#888", display: "flex", alignItems: "center" }}>
              <span style={{ 
              display: "inline-flex", 
              justifyContent: "center", 
              alignItems: "center", 
              width: "20px", 
              height: "20px", 
              borderRadius: "50%", 
              backgroundColor: "blue", 
              color: "white", 
              fontSize: "12px", 
              marginRight: "4px" 
              }}>
              {node.id === 'vl_onprem' ? onpremVendorsCount : node.id === 'vl_cloud' ? cloudVendorsCount : vendorsCount}
              </span>
            </span>
          )}
          {node.label === "Asset Type" && (
            <span style={{ marginLeft: "8px", fontSize: "12px", color: "#888", display: "flex", alignItems: "center" }}>
              <span style={{ 
              display: "inline-flex", 
              justifyContent: "center", 
              alignItems: "center", 
              width: "20px", 
              height: "20px", 
              borderRadius: "50%", 
              backgroundColor: "blue", 
              color: "white", 
              fontSize: "12px", 
              marginRight: "4px" 
              }}>
              {assetTypeCount}
              </span>
            </span>
          )}
          {(node.label === "Regions" || node.label === "Region") && (
            <span style={{ marginLeft: "8px", fontSize: "12px", color: "#888", display: "flex", alignItems: "center" }}>
              <span style={{ 
              display: "inline-flex", 
              justifyContent: "center", 
              alignItems: "center", 
              width: "20px", 
              height: "20px", 
              borderRadius: "50%", 
              backgroundColor: "blue", 
              color: "white", 
              fontSize: "12px", 
              marginRight: "4px" 
              }}>
              {regionsCount}
              </span>
            </span>
          )}
          {(node.label === "Model" || node.label === "Models") && (
            <span style={{ marginLeft: "8px", fontSize: "12px", color: "#888", display: "flex", alignItems: "center" }}>
              <span style={{ 
              display: "inline-flex", 
              justifyContent: "center", 
              alignItems: "center", 
              width: "20px", 
              height: "20px", 
              borderRadius: "50%", 
              backgroundColor: "blue", 
              color: "white", 
              fontSize: "12px", 
              marginRight: "4px" 
              }}>
              {modelsCount}
              </span>
            </span>
          )}
          {(node.label === "Accounts" || node.label === "Account") && (
            <span style={{ marginLeft: "8px", fontSize: "12px", color: "#888", display: "flex", alignItems: "center" }}>
              <span style={{ 
              display: "inline-flex", 
              justifyContent: "center", 
              alignItems: "center", 
              width: "20px", 
              height: "20px", 
              borderRadius: "50%", 
              backgroundColor: "blue", 
              color: "white", 
              fontSize: "12px", 
              marginRight: "4px" 
              }}>
              {accountsCount}
              </span>
            </span>
          )}
          {(node.label === "Cloud Regions" || node.label === "Cloud Region") && (
            <span style={{ marginLeft: "8px", fontSize: "12px", color: "#888", display: "flex", alignItems: "center" }}>
              <span style={{ 
              display: "inline-flex", 
              justifyContent: "center", 
              alignItems: "center", 
              width: "20px", 
              height: "20px", 
              borderRadius: "50%", 
              backgroundColor: "blue", 
              color: "white", 
              fontSize: "12px", 
              marginRight: "4px" 
              }}>
              {cloudRegionsCount}
              </span>
            </span>
          )}
          {(node.label === "Resource Type" || node.label === "Resource Types") && (
            <span style={{ marginLeft: "8px", fontSize: "12px", color: "#888", display: "flex", alignItems: "center" }}>
              <span style={{ 
              display: "inline-flex", 
              justifyContent: "center", 
              alignItems: "center", 
              width: "20px", 
              height: "20px", 
              borderRadius: "50%", 
              backgroundColor: "blue", 
              color: "white", 
              fontSize: "12px", 
              marginRight: "4px" 
              }}>
              {resourceTypesCount}
              </span>
            </span>
          )}
        </div>
      }
    >
      {node.data?.map((child:any) => (
        <TreeNode
          key={child.id}
          node={child}
          checkedNodes={checkedNodes}
          indeterminateNodes={indeterminateNodes}
          onToggle={onToggle}
          assetTypeCount={assetTypeCount}
          regionsCount={regionsCount}
          vendorsCount={vendorsCount}
          modelsCount={modelsCount}
          accountsCount={accountsCount}
          cloudRegionsCount={cloudRegionsCount}
          resourceTypesCount={resourceTypesCount}
          onpremCount={onpremCount}
          cloudCount={cloudCount}
          onpremVendorsCount={onpremVendorsCount}
          cloudVendorsCount={cloudVendorsCount}
        />
      ))}
    </TreeItem>
  );
};

const Tree = forwardRef(({ data, setFilterTypeData, searchQuery = '' }:any, ref) => {
  const [checkedNodes, setCheckedNodes] = useState(new Set());
  const [indeterminateNodes, setIndeterminateNodes] = useState(new Set());
  const [filteredData, setFilteredData] = useState(data);
  const [assetTypeCount, setAssetTypeCount] = useState<any>(0);
  const [regionsCount, setRegionsCount] = useState<any>(0);
  const [vendorsCount, setVendorsCount] = useState<any>(0);
  const [modelsCount, setModelsCount] = useState<any>(0);
  const [accountsCount, setAccountsCount] = useState<any>(0);
  const [cloudRegionsCount, setCloudRegionsCount] = useState<any>(0);
  const [resourceTypesCount, setResourceTypesCount] = useState<any>(0);
  const [onpremCount, setOnpremCount] = useState<any>(0);
  const [cloudCount, setCloudCount] = useState<any>(0);
  const [onpremVendorsCount, setOnpremVendorsCount] = useState<any>(0);
  const [cloudVendorsCount, setCloudVendorsCount] = useState<any>(0);
  const findNodeByLabel = (nodes: any[], label: string): any => {
    for (let node of nodes) {
      if (node.label === label) return node;
      if (node.data) {
        const found = findNodeByLabel(node.data, label);
        if (found) return found;
      }
    }
    return null;
  };

  const clearInfo = () => {
    setCheckedNodes(new Set());
    setIndeterminateNodes(new Set());
    const regionsNode = findNodeByLabel(filteredData, "Regions") || findNodeByLabel(filteredData, "Region");
    const assetTypeNode = findNodeByLabel(filteredData, "Asset Type");
    const vendorsNode = findNodeByLabel(filteredData, "Vendors");
    const modelsNode = findNodeByLabel(filteredData, "Model") || findNodeByLabel(filteredData, "Models");
    const accountsNode = findNodeByLabel(filteredData, "Accounts") || findNodeByLabel(filteredData, "Account");
    const cloudRegionsNode = findNodeByLabel(filteredData, "Cloud Regions") || findNodeByLabel(filteredData, "Cloud Region");
    const resourceTypesNode = findNodeByLabel(filteredData, "Resource Type") || findNodeByLabel(filteredData, "Resource Types");

    setRegionsCount(countSelectedCheckboxes(regionsNode?.data || []));
    setAssetTypeCount(countSelectedCheckboxes(assetTypeNode?.data || []));
    setVendorsCount(countSelectedCheckboxes(vendorsNode?.data || []));
    setModelsCount(countSelectedCheckboxes(modelsNode?.data || []));
    setAccountsCount(countSelectedCheckboxes(accountsNode?.data || []));
    setCloudRegionsCount(countSelectedCheckboxes(cloudRegionsNode?.data || []));
    setResourceTypesCount(countSelectedCheckboxes(resourceTypesNode?.data || []));
  }
  React.useImperativeHandle(ref, () => ({
    triggerClear: clearInfo,
    triggerReset: resetInfo,  
  }));
  const resetInfo = (resetData: any) => {
    setCheckedNodes(new Set());
    setIndeterminateNodes(new Set());
    const checked = new Set();
    const indeterminate = new Set();
    
    const initializeCheckedState = (node:any) => {
      if (node?.selected) checked.add(node.id);
      if (node?.data?.length > 0) {
        node.data.forEach(initializeCheckedState);
        updateParentState(node, checked, indeterminate);
      }
    };

    resetData.forEach(initializeCheckedState);
    setCheckedNodes(checked);
    setIndeterminateNodes(indeterminate);
  }

  useEffect(() => {
    let regionsCount = 0;
    let assetTypeCount = 0;
    let vendorsCount = 0;
    let modelsCount = 0;
    let accountsCount = 0;
    let cloudRegionsCount = 0;
    let resourceTypesCount = 0;
    let onpremTotal = 0;
    let cloudTotal = 0;
    let onpremVendors = 0;
    let cloudVendorsTotal = 0;
  
    const countCategories = (nodes: any[], parentType?: string) => {
      nodes.forEach((node) => {
        if (node.label === "Regions" || node.label === "Region") {
          const count = countSelectedCheckboxes(node.data);
          regionsCount += count;
          if (parentType === 'onprem') onpremTotal += count;
          if (parentType === 'cloud') cloudTotal += count;
        } else if (node.label === "Asset Type") {
          const count = countSelectedCheckboxes(node.data);
          assetTypeCount += count;
          if (parentType === 'onprem') onpremTotal += count;
          if (parentType === 'cloud') cloudTotal += count;
        } else if (node.label === "Vendors") {
          const count = countSelectedCheckboxes(node.data);
          vendorsCount += count;
          if (parentType === 'onprem') { onpremTotal += count; onpremVendors += count; }
          if (parentType === 'cloud') { cloudTotal += count; cloudVendorsTotal += count; }
        } else if (node.label === "Model" || node.label === "Models") {
          const count = countSelectedCheckboxes(node.data);
          modelsCount += count;
          if (parentType === 'onprem') onpremTotal += count;
          if (parentType === 'cloud') cloudTotal += count;
        } else if (node.label === "Accounts" || node.label === "Account") {
          const count = countSelectedCheckboxes(node.data);
          accountsCount += count;
          if (parentType === 'onprem') onpremTotal += count;
          if (parentType === 'cloud') cloudTotal += count;
        } else if (node.label === "Cloud Regions" || node.label === "Cloud Region") {
          const count = countSelectedCheckboxes(node.data);
          cloudRegionsCount += count;
          if (parentType === 'onprem') onpremTotal += count;
          if (parentType === 'cloud') cloudTotal += count;
        } else if (node.label === "Resource Type" || node.label === "Resource Types") {
          const count = countSelectedCheckboxes(node.data);
          resourceTypesCount += count;
          if (parentType === 'onprem') onpremTotal += count;
          if (parentType === 'cloud') cloudTotal += count;
        }
        if (node.data) {
          // Track which module we're inside
          const currentParent = (node.type === 'onprem' || node.type === 'cloud') ? node.type : parentType;
          countCategories(node.data, currentParent);
        }
      });
    };
  
    countCategories(filteredData);
  
    setRegionsCount(regionsCount);
    setAssetTypeCount(assetTypeCount);
    setVendorsCount(vendorsCount);
    setModelsCount(modelsCount);
    setAccountsCount(accountsCount);
    setCloudRegionsCount(cloudRegionsCount);
    setResourceTypesCount(resourceTypesCount);
    setOnpremCount(onpremTotal);
    setCloudCount(cloudTotal);
    setOnpremVendorsCount(onpremVendors);
    setCloudVendorsCount(cloudVendorsTotal);
  }, [filteredData]);

  useEffect(() => {
    const checked = new Set();
    const indeterminate = new Set();
    const initializeCheckedState = (node:any) => {
      if (node?.selected) checked.add(node.id);
      if (node?.data?.length > 0) {
        node.data.forEach(initializeCheckedState);
        updateParentState(node, checked, indeterminate);
      }
    };

    data.forEach(initializeCheckedState);
    setCheckedNodes(checked);
    setIndeterminateNodes(indeterminate);
  }, [data]);

  useEffect(() => {
    if (!searchQuery) {
      setFilteredData(data);
      return;
    }

    const filterNodes = (nodes:any) => {
      return nodes
        .map((node:any) => {
          if (node.label.toLowerCase().includes(searchQuery.toLowerCase())) {
            return node;
          }
          if (node.data) {
            const filteredChildren = filterNodes(node.data);
            if (filteredChildren.length) {
              return { ...node, data: filteredChildren };
            }
          }
          return null;
        })
        .filter(Boolean);
    };

    setFilteredData(filterNodes(data));
  }, [searchQuery, data]);

  const getAllChildren = (node: any) => {
    return node.data && node.data.length > 0
      ? node.data.flatMap(getAllChildren).concat(node.id)
      : [node.id];
  };

  const toggleCheck = (nodeId: any, isChecked: any) => {
    setCheckedNodes((prevChecked: any) => {
      let updatedChecked = new Set(prevChecked);
      let updatedIndeterminate = new Set();

      const node = findNodeById(data, nodeId);
      if (!node) return prevChecked;

      const allChildren = getAllChildren(node);
      if (isChecked) {
        allChildren.forEach((id: any) => updatedChecked.add(id));
      } else {
        allChildren.forEach((id: any) => updatedChecked.delete(id));
      }

      data.forEach((n: any) => updateParentState(n, updatedChecked, updatedIndeterminate));
      setIndeterminateNodes(updatedIndeterminate);
      setCheckedNodes(updatedChecked);
      setFilterTypeData(updateTreeData(data, updatedChecked, updatedIndeterminate));
      return updatedChecked;
    });
  };

  const updateParentState = (node: any, checkedSet: any, indeterminateSet: any) => {
    if (!node.data || node.data.length === 0) return;
    node.data.forEach((child: any) => updateParentState(child, checkedSet, indeterminateSet));

    const allChecked = node.data.length > 0 && node.data.every((child: any) => checkedSet.has(child.id));
    const someChecked = node.data.some((child: any) => checkedSet.has(child.id));
    const someIndeterminate = node.data.some((child: any) => indeterminateSet.has(child.id));

    if (allChecked) {
      checkedSet.add(node.id);
      indeterminateSet.delete(node.id);
    } else if (someChecked || someIndeterminate) {
      indeterminateSet.add(node.id);
      checkedSet.delete(node.id);
    } else {
      indeterminateSet.delete(node.id);
      checkedSet.delete(node.id);
    }
  };

  const updateTreeData = (nodes:any, checkedSet:any, indeterminateSet:any) => {
    return nodes.map((node:any) => ({
      ...node,
      selected: checkedSet.has(node.id),
      indeterminate: indeterminateSet.has(node.id),
      data: node.data ? updateTreeData(node.data, checkedSet, indeterminateSet) : undefined,
    }));
  };

  const findNodeById = (nodes:any, id:any):any => {
    for (let node of nodes) {
      if (node.id === id) return node;
      if (node.data) {
        const found:any = findNodeById(node.data, id);
        if (found) return found;
      }
    }
    return null;
  };
  const handleSelectAll = (isChecked:any) => {
    if (isChecked) {
      const allNodes = new Set(data.flatMap(getAllChildren));
      setCheckedNodes(allNodes);
      setIndeterminateNodes(new Set());
      const updatedData = updateTreeData(data, allNodes, new Set());
      setFilterTypeData(updatedData);
    } else {
      setCheckedNodes(new Set());
      setIndeterminateNodes(new Set());
      const updatedData = updateTreeData(data, new Set(), new Set());
      setFilterTypeData(updatedData);
    }
  };
  
  return (
    <div className="left-filter g-height">
      <FormControlLabel
       sx={{ 
        "& .MuiTypography-root": { gap: 0, fontSize: "13px" } 
        }}
        control={
          <Checkbox
            onChange={(e) => handleSelectAll(e.target.checked)}
            checked={checkedNodes.size === data.flatMap(getAllChildren).length}
            indeterminate={checkedNodes.size > 0 && checkedNodes.size < data.flatMap(getAllChildren).length}
          />
        }
        label="All"
      />
      <SimpleTreeView  sx={{ 
        "& .MuiTypography-root": { fontSize: "13px" } 
        }}>
        {filteredData.map((node: any) => (
          <TreeNode
            sx={{ "& .MuiTreeItem-label": { fontSize: "13px" } }}
            key={node.id}
            node={node}
            checkedNodes={checkedNodes}
            indeterminateNodes={indeterminateNodes}
            onToggle={toggleCheck}
            assetTypeCount={assetTypeCount}
            regionsCount={regionsCount} 
            vendorsCount={vendorsCount}
            modelsCount={modelsCount}
            accountsCount={accountsCount}
            cloudRegionsCount={cloudRegionsCount}
            resourceTypesCount={resourceTypesCount}
            onpremCount={onpremCount}
            cloudCount={cloudCount}
            onpremVendorsCount={onpremVendorsCount}
            cloudVendorsCount={cloudVendorsCount}
          />
          
        ))}
      </SimpleTreeView>
    </div>

  );
});

export default Tree;